import { NoSsr } from '@cian/react-utils';
import { UIText3 } from '@cian/ui-kit';
import * as React from 'react';

import { useUserStatus } from './hooks';

interface ICompanionStatusContainerProps {
  companionId?: number;
}

export const CompanionStatusContainer = ({ companionId }: ICompanionStatusContainerProps) => {
  const { companionStatus } = useUserStatus(companionId as number);

  return (
    <NoSsr>
      <UIText3 color="text-secondary-default">{companionStatus}</UIText3>
    </NoSsr>
  );
};
